const readAsDataURL = (file: File): Promise<string> =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onerror = reject;
        reader.onload = (ev: ProgressEvent<FileReader>) => {
            if (ev.target) {
                resolve(ev.target.result as string);
            }
        };
        reader.readAsDataURL(file);
    });

export default readAsDataURL;
